export default __webpack_public_path__ + "static/media/grid_1__03.a63b73d2.jpg";